export default "__VITE_ASSET__3cf1342d__"